import { render, staticRenderFns } from "./contracts-edit.vue?vue&type=template&id=3eae0373"
import script from "./contracts-edit.vue?vue&type=script&lang=js"
export * from "./contracts-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports